import { render, staticRenderFns } from "./PopularArticleList.vue?vue&type=template&id=18b9911d&scoped=true&"
import script from "./PopularArticleList.vue?vue&type=script&lang=js&"
export * from "./PopularArticleList.vue?vue&type=script&lang=js&"
import style0 from "./PopularArticleList.vue?vue&type=style&index=0&id=18b9911d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9911d",
  null
  
)

export default component.exports